var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 3H8V4H4V3ZM2 5V4H4V5H2ZM1 6V5H2V6H1ZM1 7V6H0V7H1ZM2 8H1V7H2V8ZM4 9H2V8H4V9ZM8 9V10H4V9H8ZM10 8V9H8V8H10ZM11 7V8H10V7H11ZM11 6H12V7H11V6ZM10 5H11V6H10V5ZM10 5V4H8V5H10ZM5 5.5H7V7.5H5V5.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeS);
export default __webpack_public_path__ + "static/media/eye-s.5d22d4ab736173efa1a86e7719e6c89b.svg";
export { ForwardRef as ReactComponent };